import PropTypes from "prop-types";
import React, { Fragment } from "react";
import HeaderOne from "../wrappers/header/HeaderOne";
//import FooterOne from "../wrappers/footer/FooterOne";
import FooterTwo from "../wrappers/footer/FooterTwo";
import FooterMobile from "../wrappers/footer/FooterMobile";

const LayoutOne = ({
  children,
  headerContainerClass,
  headerTop,
  headerPaddingClass,
  footerTop
}) => {
  return (
    <Fragment>
      <HeaderOne
        layout={headerContainerClass}
        top={headerTop}
        headerPaddingClass={headerPaddingClass}
      />
      {children}

      <FooterMobile />
      {(() => {
        if (footerTop != "invisible") {
          return (
            <FooterTwo
              backgroundColorClass="bg-gray"
              spaceTopClass="pt-100"
              spaceBottomClass="pb-70"
              footer={footerTop}
            />);
        }
      })()}


    </Fragment>
  );
};

LayoutOne.propTypes = {
  children: PropTypes.array,
  headerContainerClass: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerTop: PropTypes.string
};

export default LayoutOne;
